import { createStyles, makeStyles } from '@material-ui/styles';
import palette from '../../../../theme/palette';

const style = () =>
  createStyles({
    root: {
      maxWidth: '100%',
      borderRadius: palette.borderRadius.default,
      padding: '10px',
      background: palette.common.primaryBlue
    },
    container: {
      display: 'flex',
      flexDirection: 'column',
      gap: '10px',
      width: '100%',
      color: palette.text.secondary,
      fontWeight: 700
    },
    Blue: {
      background: palette.common.primaryBlue
    },
    White: {
      color: palette.title.primary
    },
    isNotes: {
      gap: '20px'
    },
    footer: {
      display: 'flex',
      justifyContent: 'center',
      gap: '10px',
      width: '100%',
      alignItems: 'center'
    }
  });

const useStyle = makeStyles(style);
export default useStyle;
